import React, { FC } from 'react';
import cls from 'classnames';
import { DateChipProps } from './DateChip.types';
import {
	getClassNames,
	getRootClassListFromProps,
} from '../../../../utilities/classNames';

export const classNames = getClassNames('sds-date-chip', 
['is-selected', 'field', 'is-passthrough', 'is-disabled' ]);

const DateChip: FC<DateChipProps> = (props) => {
	const { className, onClick, isSelected = false, isDisabled = false, date } = props;
	return (
		<button
			className={cls(getRootClassListFromProps(classNames, props), className)}
			disabled={!date || isDisabled }
			onClick={onClick}
		>
			{date && <div className={cls(classNames.field, { [classNames.isDisabled]: isDisabled, [classNames.isSelected]: isSelected })}>
				{date.getDate()}
			</div>}
		</button>
	);
};

DateChip.displayName = 'DateChip';

export default DateChip;
